import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'visitor-mobile-home-screen',
  templateUrl: './mobile-home-screen.component.html',
  styleUrls: ['./mobile-home-screen.component.css']
})
export class MobileHomeScreenComponent implements OnInit {

  public open1: any;
  constructor() { }

  ngOnInit(): void {
  }
  openContact(event: any){
    this.open1 = event;
  }
}
